import React, { ChangeEvent } from "react";

export const honeyPotToken = "gewoongers_a_first_name";
export const HiddenInput = () => {
  const handleHiddenInput = (e: ChangeEvent<HTMLInputElement>) => {
    localStorage.setItem(honeyPotToken, e.target.value);
  };

  return (
    <input
      type="text"
      id="form_email"
      name="a_first_name"
      className="gg-hidden"
      onChange={handleHiddenInput}
      tabIndex={-1}
      autoComplete="off"
    />
  );
};
